"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Permet l'affichage d'un tooltip sur un element dom.
 *
 * un attibut tl-tooltip-position="bottom" permet de postionner le tooltip en dessous de l'élément
 */
ngModule.directive("tlTooltip", function () {
  return {
    restrict: 'A',
    link: function link($scope, $element, $attrs, ctrl) {
      if ($attrs.tlTooltipPosition) {
        $scope.tlTooltipPosition = $attrs.tlTooltipPosition;
      }
      if ($.trim($attrs.tlTooltip)) {
        ctrl.setTooltipContent($attrs.tlTooltip);
      }
    },
    controller: function controller($scope, $element) {
      var ctrl = this,
        tooltipScope = null,
        tooltipContent = null;
      ctrl.setTooltipContentLink = function (transcludeFn) {
        ctrl.destroyTooltip();
        tooltipScope = $scope.$new();
        transcludeFn(tooltipScope, function (content) {
          tooltipContent = content;
        });
        ctrl.attachTooltip();
      };
      ctrl.setTooltipContent = function (content) {
        ctrl.destroyTooltip();
        tooltipContent = content;
        ctrl.attachTooltip();
      };
      ctrl.attachTooltip = function () {
        var tooltipPosition = {
          // container : $element.closest(".main-container"),
          my: 'middle left',
          at: 'middle right',
          adjust: {
            x: 3
          },
          viewport: $(window)
        };
        if ($scope.tlTooltipPosition === 'bottom') {
          tooltipPosition = {
            my: 'top center',
            at: 'bottom center',
            adjust: {
              y: 8
            },
            viewport: $(window)
          };
        }
        _.defer(function () {
          // the defer is required to attach to re-compiled directives (tl-input-wrapper)
          var tooltipLength;
          if (_.isString(tooltipContent)) {
            tooltipLength = _.trim(tooltipContent).length;
          } else {
            tooltipLength = _.trim(tooltipContent.text()).length;
          }

          // n'affiche le tooltip que si il y a un contenu
          if (tooltipLength > 0) {
            $element.qtip({
              content: {
                text: tooltipContent
              },
              show: {
                delay: 200,
                solo: true
              },
              position: tooltipPosition,
              style: {
                classes: 'qtip-tl-tooltip' // TODO : allow easy parametrization
              }
            });
          }
        });
      };
      ctrl.destroyTooltip = function () {
        $element.qtip("destroy", true);
        if (tooltipScope != null) {
          tooltipScope.$destroy();
          tooltipScope = null;
        }
      };
      $scope.$on("$destroy", function () {
        ctrl.destroyTooltip();
      });
    }
  };
});

/**
 * Permet d'utiliser du html dans le contenu des tooltips
 */
ngModule.directive("tlTooltipContent", function () {
  return {
    restrict: 'E',
    require: "^?tlTooltip",
    transclude: true,
    scope: true,
    link: function link($scope, $el, $attrs, tooltipCtrl, transcludeFn) {
      if (tooltipCtrl) {
        tooltipCtrl.setTooltipContentLink(transcludeFn);
      } else if ($attrs.tlTooltipId) {
        _.defer(function () {
          // defer to let angular finish the template linking. we never know.
          var target = $el.siblings().filter("[tl-tooltip-id='" + $attrs.tlTooltipId + "']");
          if (target.length) {
            target.controller("tlTooltip").setTooltipContentLink(transcludeFn);
          }
        });
      } else {
        throw "tlTooltipContent requires either a parent tlTooltip or to specify the tl-tooltip-id attribute";
      }
      $el.hide();
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/tl/tlTooltip.js
// module id = 2910
// module chunks = 13